<template>
    <div>
        <iframe :src="iframesrc"  class="iframe"></iframe>
    </div>
</template>

<script>
export default {
    data() {
        return {
            iframesrc: '',
            exhibition_id: '',
        };
    },
    mounted() {
        this.isShow = false;
        this.$root.$on("close", (idName, router) => {
            this.flagNum = 0;
        });
        // this.$refs.video.currentTime = 5;
        // this.$refs.video.addEventListener("ended", () => {
        //     this.isShow = true;
        // });
        this.exhibition_id = this.$route.query.exhibition_id
        console.log(this.exhibition_id)
        if(this.exhibition_id){
            switch (this.exhibition_id) {
                case '21':
                    this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=706a8f6f7d7fc971";
                    break;
                case '25':
                    this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=a8358f79fefa2d5e";
                    break;
                case '31':
                    this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=b19a0b4a4ed3d5e2";
                    break;
                case '41':
                    this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=511b244aa85c8c38";
                    break;
                default:
                    break;
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.iframe{
    width: 100%;
    border: 0px;
    height: 14.5rem;
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/mobileSmallconference/index.vue